export default __webpack_public_path__ + "static/media/lakshmiPriya.23a3e6bc.jpg";